module.exports = __webpack_public_path__ + "img/wave-pulse.fb4e7d65.svg";